// extracted by mini-css-extract-plugin
export default {"illustration-36-36":"PreferenceOptionsPage-module__illustration-36-36__m739T"};